import { ButtonsAddComponent } from './component-table/buttons-add.component';
// @Angular
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

// Third party
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { TabsModule } from 'ngx-bootstrap/tabs';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
  OWL_DATE_TIME_FORMATS,
  OwlDateTimeIntl,
  OWL_DATE_TIME_LOCALE
} from 'ng-pick-datetime';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { NgSelectModule } from '@ng-select/ng-select';
import { PrettyJsonModule } from 'angular2-prettyjson';
import { Ng2FileInputModule, Ng2FileInputComponent } from 'ng2-file-input';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { DragulaModule } from 'ng2-dragula';
import { CollapseModule } from 'ngx-bootstrap/collapse';

// Local components
import { LoaderComponent } from './loader/loader.component';
import * as directives from './directives';
import { DynamicFormComponent, DynamicFormControlComponent } from './dynamic-form';
import { ConfirmComponent } from './confirm/confirm.component';
import { DateFormatPipe } from './pipes/moment/date-format.pipe';
import { DateCalendarPipe } from './pipes/moment/date-calendar.pipe';
import { UrlSanitizerPipe } from './pipes/url-sanitizer.pipe';
import { EmptyComponent } from './empty/empty.component';
import { ModalTableComponent } from './modal-table/modal-table.component';
import { MY_NATIVE_FORMATS, DefaultIntl } from './util/config-default-datetimepicker';
import * as componetTable from './component-table';
import { RefactorDynamicFormComponent } from './refactor-dynamic-form/refactor-dynamic-form.component';
import { ControlMessagesComponent } from './control-messages/control-messages.component';
import { LoadInformationExcelComponent } from './load-information-excel/load-information-excel.component';
import { ModalSelectComponent } from './modal-select/modal-select.component';
import { RefactoryMasterTableComponent } from './refactory-master-table/refactory-master-table.component';
import { DynamicViewComponent } from './dynamic-view/dynamic-view.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { TitleComponent } from './title';
import { ActivityComponent } from './activity/activity.component';
import { GhostBoxComponent } from './ghost-box/ghost-box.component';
import { ElementsHelperComponent } from './elements-helper/elements-helper.component';
import { SelectTramiteComponent } from './select-tramite/select-tramite.component';
import { StageComponent } from './title/stage/stage.component';
import { DynamicContentFormComponent } from '@app/components/dynamic-content-form/dynamic-content-form.component';
import { ObservationProcessComponent } from './observation-process/observation-process.component';
import { TaskComponent } from './task/task.component';
import { VitalRequestsViewComponent } from './view-vital-requests/view-vital-requests.component';



import { TinymceEditorComponent } from './tinymce-editor/tinymce-editor.component';
import { TINYMCE_SCRIPT_SRC, EditorModule } from '@tinymce/tinymce-angular';
import { Const } from '@app/shared';
import { environment } from '@env/environment';
import { ReassigmentResponsiblesComponent } from './reassigment-responsibles/reassigment-responsibles.component';
import { HistoryTaskComponent } from './history-task/history-task.component';
import { HistoryTaskUsersComponent } from './history-task-users/history-task-users.component';
import { AnnulationProcessComponent } from './annulation-process/annulation-process.component';
import { DocumentsRecordsComponent } from './documents-records/documents-records.component';
import { ProcedureMonitoringComponent } from './procedure-monitoring/procedure-monitoring.component';
import { ScannerComponent } from './scanner/scanner.component';
import { TitlePreviewComponent } from './title-preview/title-preview.component';
import { StagePreviewComponent } from './title-preview/stage-preview/stage-preview.component';
import { ActivityPreviewComponent } from './activity-preview/activity-preview.component';
import { TaskPreviewComponent } from './task-preview/task-preview.component';
import { DocumentsRecordsPreviewComponent } from './documents-records-preview/documents-records-preview.component';
import { UsersTaskComponent } from './users-task-management/users-task-management.component';
import {AttachedDocumentExpedientComponent } from './attached-document-exp/attached-document-exp.component';
import { FileUploadModule } from 'primeng/fileupload';
import { ProcedureStatusComponent } from './procedure-status-utility/procedure-status-utility.component';
import { SelectTramiteDuplicateComponent } from './select-tramite-duplicate/select-tramite-duplicate.component';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PrettyJsonModule,
    BsDropdownModule,
    ModalModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    BsDatepickerModule,
    TypeaheadModule,
    Ng2SmartTableModule,
    NgSelectModule,
    Ng2FileInputModule,
    ScrollToModule,
    DragulaModule,
    CollapseModule,
    EditorModule,
    FileUploadModule,
    TabsModule.forRoot(),
  ],
  entryComponents: [
    DynamicContentFormComponent,
    componetTable.CustomEditorComponent,
    componetTable.ButtonViewComponent,
    componetTable.ButtonDownloadReviewComponent,
    componetTable.ButtonDownloadComponent,
    componetTable.ButtonViewFormDynamicComponent,
    componetTable.ButtonsAccionDynamicFormsTableComponent,
    componetTable.RangeRefactoryTableDynamicComponent,
    componetTable.ButtonsAssociateDocumentComponent,
    componetTable.ButtonsDeleteComponent,
    componetTable.CalendarRefactoryTableDynamicComponent,
    componetTable.DateTimerRefactoryTableDynamicComponent,
    componetTable.RangeDateRefactoryTableDynamicComponent,
    componetTable.RangeTimerRefactoryTableDynamicComponent,
    componetTable.TimerRefactoryTableDynamicComponent,
    componetTable.CoordinateDynamicFormsComponent,
    componetTable.ButtonsActionsTableComponent,
    componetTable.ButtonsActionsTableHelpsComponent,
    componetTable.CheckTableComponent,
    componetTable.RadioButtonsCheckListComponent,
    componetTable.StatusTramiteComponent,
    componetTable.DateStringComponent,
    componetTable.InfoRadicationDocComponent,
    componetTable.DynamcColumnComponent,
    componetTable.NameUserAssignmentComponent,
    componetTable.ButtonDownloadDeleteComponent,
    componetTable.RowSelectionCheckboxComponent,
    componetTable.InputTableComponent,
    componetTable.ButtonDownloadCheckComponent,
    componetTable.ThousandsSeparatorNumberFormatComponent,
    componetTable.LabelNgSelectDynamicTableComponent,
    componetTable.ButtonsAddComponent,
    componetTable.RichTextAreaComponent,
    Ng2FileInputComponent,
    DynamicFormComponent,
    componetTable.ButtonsAnnulationDocumentsComponent,
    componetTable.ColorRowTableComponent,
    componetTable.ButtonViewFlowComponent,
    componetTable.ButtonViewAttachmentsComponent,
    componetTable.ButtonPreviewDocCheckComponent,
    componetTable.ButtonPreviewDocComponent,
    componetTable.ButtonDownloadReviewModifyComponent,
  ],
  declarations: [
    LoaderComponent,
    directives.ClickStopPropagationDirective,
    DynamicFormComponent,
    DynamicFormControlComponent,
    ConfirmComponent,
    EmptyComponent,
    DateFormatPipe,
    DateCalendarPipe,
    UrlSanitizerPipe,
    ModalTableComponent,
    componetTable.CustomEditorComponent,
    componetTable.ButtonViewComponent,
    componetTable.ButtonDownloadReviewComponent,
    componetTable.ButtonDownloadComponent,
    componetTable.ButtonViewFormDynamicComponent,
    componetTable.ButtonsAccionDynamicFormsTableComponent,
    RefactorDynamicFormComponent,
    componetTable.RangeRefactoryTableDynamicComponent,
    componetTable.ButtonsAssociateDocumentComponent,
    componetTable.ButtonsAddComponent,
    componetTable.ButtonsDeleteComponent,
    ControlMessagesComponent,
    componetTable.CalendarRefactoryTableDynamicComponent,
    componetTable.DateTimerRefactoryTableDynamicComponent,
    componetTable.RangeDateRefactoryTableDynamicComponent,
    componetTable.RangeTimerRefactoryTableDynamicComponent,
    componetTable.TimerRefactoryTableDynamicComponent,
    componetTable.CoordinateDynamicFormsComponent,
    componetTable.ButtonsActionsTableComponent,
    componetTable.ButtonsActionsTableHelpsComponent,
    componetTable.CheckTableComponent,
    componetTable.RadioButtonsCheckListComponent,
    componetTable.StatusTramiteComponent,
    componetTable.DateStringComponent,
    componetTable.InfoRadicationDocComponent,
    componetTable.DynamcColumnComponent,
    componetTable.NameUserAssignmentComponent,
    componetTable.ButtonDownloadDeleteComponent,
    componetTable.RowSelectionCheckboxComponent,
    componetTable.InputTableComponent,
    componetTable.ButtonDownloadCheckComponent,
    componetTable.ThousandsSeparatorNumberFormatComponent,
    componetTable.LabelNgSelectDynamicTableComponent,
    componetTable.RichTextAreaComponent,
    componetTable.ButtonDownloadReviewModifyComponent,
    LoadInformationExcelComponent,
    ModalSelectComponent,
    RefactoryMasterTableComponent,
    directives.CustomMinDirective,
    directives.CustomMinEqualDirective,
    directives.CustomMaxDirective,
    directives.CustomMaxEqualDirective,
    directives.CustomDecimalMaxDirective,
    directives.ThousandsSeparatorDirective,
    directives.FormatNumberDirective,
    DynamicViewComponent,
    ChangePasswordComponent,
    ActivityComponent,
    ActivityPreviewComponent,
    GhostBoxComponent,
    ElementsHelperComponent,
    SelectTramiteComponent,
    SelectTramiteDuplicateComponent,
    TaskComponent,
    TaskPreviewComponent,
    TitleComponent,
    TitlePreviewComponent,
    StageComponent,
    StagePreviewComponent,
    DynamicContentFormComponent,
    ObservationProcessComponent,
    TinymceEditorComponent,
    ReassigmentResponsiblesComponent,
    HistoryTaskComponent,
    HistoryTaskUsersComponent,
    UsersTaskComponent,
    ScannerComponent,
    DocumentsRecordsComponent,
    DocumentsRecordsPreviewComponent,
    AnnulationProcessComponent,
    ProcedureMonitoringComponent,
    VitalRequestsViewComponent,
    AttachedDocumentExpedientComponent,
    ProcedureStatusComponent,
    componetTable.ButtonsAnnulationDocumentsComponent,
    componetTable.ColorRowTableComponent,
    componetTable.ButtonViewFlowComponent,
    componetTable.ButtonViewAttachmentsComponent,
    componetTable.ButtonPreviewDocCheckComponent,
    componetTable.ButtonPreviewDocComponent,
  ],
  exports: [
    LoaderComponent,
    directives.ClickStopPropagationDirective,
    DynamicFormComponent,
    ConfirmComponent,
    EmptyComponent,
    ModalTableComponent,
    DateFormatPipe,
    DateCalendarPipe,
    UrlSanitizerPipe,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    Ng2SmartTableModule,
    componetTable.CustomEditorComponent,
    componetTable.ButtonViewComponent,
    componetTable.ButtonViewFormDynamicComponent,
    NgSelectModule,
    RefactorDynamicFormComponent,
    componetTable.RangeRefactoryTableDynamicComponent,
    componetTable.ButtonsAssociateDocumentComponent,
    componetTable.ButtonsAddComponent,
    componetTable.ButtonsDeleteComponent,
    ControlMessagesComponent,
    componetTable.CalendarRefactoryTableDynamicComponent,
    componetTable.DateTimerRefactoryTableDynamicComponent,
    componetTable.RangeDateRefactoryTableDynamicComponent,
    componetTable.RangeTimerRefactoryTableDynamicComponent,
    componetTable.TimerRefactoryTableDynamicComponent,
    componetTable.CoordinateDynamicFormsComponent,
    componetTable.ButtonsActionsTableComponent,
    componetTable.ButtonsActionsTableHelpsComponent,
    componetTable.CheckTableComponent,
    componetTable.RadioButtonsCheckListComponent,
    componetTable.StatusTramiteComponent,
    componetTable.DateStringComponent,
    componetTable.InfoRadicationDocComponent,
    componetTable.DynamcColumnComponent,
    componetTable.NameUserAssignmentComponent,
    componetTable.ButtonDownloadDeleteComponent,
    componetTable.RowSelectionCheckboxComponent,
    componetTable.InputTableComponent,
    componetTable.ButtonDownloadCheckComponent,
    componetTable.ThousandsSeparatorNumberFormatComponent,
    componetTable.LabelNgSelectDynamicTableComponent,
    componetTable.RichTextAreaComponent,
    LoadInformationExcelComponent,
    ModalSelectComponent,
    directives.CustomMinDirective,
    directives.CustomMaxDirective,
    directives.CustomDecimalMaxDirective,
    directives.ThousandsSeparatorDirective,
    directives.FormatNumberDirective,
    PrettyJsonModule,
    RefactoryMasterTableComponent,
    DynamicViewComponent,
    TabsModule,
    ChangePasswordComponent,
    ActivityComponent,
    ActivityPreviewComponent,
    GhostBoxComponent,
    ElementsHelperComponent,
    SelectTramiteComponent,
    SelectTramiteDuplicateComponent,
    TaskComponent,
    TaskPreviewComponent,
    TitleComponent,
    TitlePreviewComponent,
    ScannerComponent,
    ObservationProcessComponent,
    TinymceEditorComponent,
    VitalRequestsViewComponent,
    AttachedDocumentExpedientComponent,
    ProcedureStatusComponent,
    componetTable.ButtonsAnnulationDocumentsComponent,
    componetTable.ColorRowTableComponent,
    componetTable.ButtonViewFlowComponent,
    componetTable.ButtonViewAttachmentsComponent,
    componetTable.ButtonPreviewDocCheckComponent,
    componetTable.ButtonPreviewDocComponent,
  ],
  providers: [
    // idioma de la libreria NgPickDateTime
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'es-CO' },
    // formato de fechas libreria NgPickDateTime
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_NATIVE_FORMATS },
    // default de variables de la libreria
    { provide: OwlDateTimeIntl, useValue: DefaultIntl },
    { provide: TINYMCE_SCRIPT_SRC, useValue: environment.servers_integrations.CITA.EDITORURL }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts